import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, Cancel as FailureIcon} from "@material-ui/icons"
import {red} from "@material-ui/core/colors"

import {CustomerPaymentArrangementCancelled} from "@indebted/api"

function PaymentArrangementCancelledActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerPaymentArrangementCancelled},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<FailureIcon style={{color: red[500]}} />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>ID:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.PaymentArrangementID}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Reason:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Reason}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {PaymentArrangementCancelledActivity}
